export interface FormatOptions {
    prefixLength?: number; // 前缀长度，默认5
    suffixLength?: number; // 后缀长度，默认3
    maxLength?: number; // 最大长度，默认10
    ellipsis?: string; // 省略号，默认'...'
}


/**
 * 附件显示名称贵方
 */
export const getFileName = (fileName: string, options?: FormatOptions) => {
    if (!fileName) return "";
    const defaultValue = { prefixLength: 5, suffixLength: 3, ellipsis: "...", maxLength: 10 };
    const { prefixLength, suffixLength, ellipsis, maxLength } = { ...defaultValue, ...options };
    if (fileName.length <= maxLength) {
        return fileName;
    }
    // 参数验证
    if (prefixLength + suffixLength >= maxLength) {
        throw new Error("前缀长度 + 后缀长度必须小于最大长度");
    }

    const lastDotIndex = fileName.lastIndexOf(".");
    let name: string;
    let extension: string = "";

    if (lastDotIndex === -1) {
        name = fileName;
    } else {
        name = fileName.slice(0, Math.max(0, lastDotIndex));
        extension = fileName.slice(Math.max(0, lastDotIndex));
    }

    // 如果文件名长度不超过最大长度，直接返回
    if (name.length <= maxLength) {
        return fileName;
    }

    const prefix = name.slice(0, Math.max(0, prefixLength));
    const suffix = name.slice(Math.max(0, name.length - suffixLength));

    return `${prefix}${ellipsis}${suffix}${extension}`;
};

// 获取文件长度
export const getFileNameLen = (fileName: string) => {
    const lastDotIndex = fileName.lastIndexOf(".");
    const name = fileName.slice(0, Math.max(0, lastDotIndex));
    return name.length;
};
